import { Bell, Menu, ChevronDown, User } from 'lucide-react'
import { Badge, Navbar } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import { firstLetterUpperCase } from '../../utils/TextFormatter'
import styles from './dashboard.module.css'

const NavbarPage = ({
  onClick,
  indicator,
  width,
  setShowCanvas = false,
  setShowCanvasWarehouse = false,
  usernameProp
}) => {
  const navigate = useNavigate()
  const username = usernameProp?.username?.username || 'User'

  return (
    <Navbar className={styles.navbar} expand={false}>
      <div className="d-flex align-items-center">
        <button
          className={`${styles.iconButton} me-3`}
          onClick={() => (width <= 768 ? setShowCanvas(true) : onClick())}
        >
          <Menu size={20} />
        </button>
        {width > 768 && (
          <h5 className={`mb-0 ${styles.navbarBrand}`}>Dashboard</h5>
        )}
      </div>

      <div className="d-flex align-items-center gap-3">
        <div
          className={`${styles.iconButton} position-relative`}
          onClick={() => navigate('/notification')}
        >
          <Bell size={20} />
          {indicator && (
            <Badge
              bg="danger"
              className="position-absolute top-25 start-75 translate-middle p-1 border border-light rounded"
            >
              <span className="visually-hidden">New alerts</span>
            </Badge>
          )}
        </div>

        <div
          className={styles.userProfileContainer}
          onClick={() => setShowCanvasWarehouse(true)}
        >
          <div className={styles.userAvatar}>
            <User size={14} />
          </div>
          <div className={styles.userInfo}>
            <span className={styles.userName}>
              {firstLetterUpperCase(username)}
            </span>
          </div>
          <ChevronDown className="ms-3 text-secondary" size={14} />
        </div>
      </div>
    </Navbar>
  )
}

export default NavbarPage
